import React from 'react';
import { BellIcon } from '@heroicons/react/24/outline';
import { useNotifications } from '../contexts/NotificationContext';

interface NotificationBadgeProps {
  className?: string;
  onClick?: () => void;
}

/**
 * NotificationBadge - 通知徽章組件
 * 顯示未讀通知數量
 */
const NotificationBadge: React.FC<NotificationBadgeProps> = ({ className = '', onClick }) => {
  const { unreadCount } = useNotifications();

  if (unreadCount === 0) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`relative p-2 text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary rounded-lg ${className}`}
        aria-label="通知"
      >
        <BellIcon className="h-6 w-6" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative p-2 text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary rounded-lg ${className}`}
      aria-label={`${unreadCount} 則未讀通知`}
    >
      <BellIcon className="h-6 w-6" />
      <span className="absolute top-0 right-0 flex items-center justify-center h-5 w-5 text-xs font-bold text-white bg-red-500 rounded-full transform translate-x-1/2 -translate-y-1/2">
        {unreadCount > 99 ? '99+' : unreadCount}
      </span>
    </button>
  );
};

export default NotificationBadge;
